//@ts-nocheck
import isUrl from 'is-url'
import { findEmbedType } from '../Embeds'

// A Vimeo embed src is very often pasted without a scheme — "player.vimeo.com/video/<id>?h=…"
// — which is the exact form quoted in RT-810. is-url requires "//", so the guard below
// rejected it and the insert bailed out with a silent `return false`: the modal closed and
// nothing was added. Upgrade a bare host to https:// only when that yields a valid URL.
export const normalizeEmbedUrl = (value) => {
  if (typeof value !== 'string') return value
  const trimmed = value.trim()
  if (!trimmed || /\s/.test(trimmed) || trimmed.startsWith('//') || /^[a-z][a-z0-9+.-]*:/i.test(trimmed)) {
    return trimmed
  }
  return isUrl(`https://${trimmed}`) ? `https://${trimmed}` : trimmed
}

export const iframeHeightOnResizeStop = (src, ref, el) => {
  if (src?.indexOf('facebook.com') > -1) {
    if (ref.current.getElementsByTagName('iframe')[0]) {
      const urlArray = ref.current.getElementsByTagName('iframe')[0].src.split("&")
      if (urlArray[urlArray.length - 1]) {
        urlArray[urlArray.length - 1] = `width=${el.style.width}`
      }
      ref.current.getElementsByTagName('iframe')[0].src = urlArray.join("&")
    }
    const handleEvent = (e) => {
      if (e.origin === "https://www.facebook.com" && (e.data)) {
        if (ref.current.getElementsByTagName('iframe')[0].contentWindow === e.source) {
          el.style.height = `${e.data.split("&")[e.data.split("&").length - 1].split("=")[1]}px`
          window.removeEventListener('message', handleEvent);
        }
      }
    }
    if (ref.current) {
      window.addEventListener('message', handleEvent)
    }
  }
  if (src?.indexOf('twitter.com') > -1) {
    const handleEvent = (e) => {
      if (e.origin === "https://platform.twitter.com" && (e.data)) {
        if (ref.current.getElementsByTagName('iframe')[0].contentWindow === e.source) {
          el.style.height = `${e.data['twttr.embed'].params[0].height + 20}px`
          window.removeEventListener('message', handleEvent)
        }
      }
    }
    if (ref.current) {
      window.addEventListener('message', handleEvent)
    }

  }
  if (src?.indexOf('instagram.com') > -1) {
    const handleEvent = (e) => {
      if (e.origin === "https://www.instagram.com" && (e.data)) {
        if (ref.current.getElementsByTagName('iframe')[0].contentWindow === e.source) {
          el.style.height = `${JSON.parse(e.data).details.height}px`
          window.removeEventListener('message', handleEvent)
        }
      }
    }
    if (ref.current) {
      window.addEventListener('message', handleEvent)
    }
  }
}



export const iFrameUrl = (url) => {
  let newAttrs;
  // Normalize smart/curly quotes to straight quotes — embed code copied via apps that
  // auto-format quotes (docs, notes, chat) otherwise breaks the src regex and DOMParser.
  let data = url?.replace(/[‘’]/g, "'").replace(/[“”]/g, '"');
  var allowed = ['iframe', 'video', 'source'];
  var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;

  data = data?.replace(/<p(.*?[^>]?)>([\w\W]*?)<\/p>/gi, '');
  data = data?.replace(tags, function ($0, $1) {
    return (allowed.indexOf($1.toLowerCase()) === -1) ? '' : $0;
  });
  const srcReg = /(src=").*?(?=[\*"])/g;
  const parser = new DOMParser();
  const htmlElement = parser.parseFromString(data, "text/html");
  if (data) {
    let matches = [...data.matchAll(srcReg)];

    matches.forEach(match => {
      if (match[0].indexOf('youtube.com') > -1) {
        newAttrs = {
          src: match[0],
        }
        htmlElement.getElementsByTagName('iframe')[0].getAttributeNames().forEach((attribute) => {
          newAttrs[attribute] = htmlElement.getElementsByTagName('iframe')[0].getAttribute(attribute)
        })
      }
      if (match[0].indexOf('facebook.com') > -1) {
        // Keep ONLY Facebook's full plugin URL (plugins/post.php|video.php?href=…) as the
        // src, read via getAttribute for a clean, entity-decoded value (no trailing-param
        // mangling). We deliberately do NOT copy the pasted iframe's other attributes
        // (width/height/style/…): Embeds.tsx renders this as a controlled iframe with a
        // fixed attribute set, and carrying a `width` attr onto the node breaks the RTE
        // Resizable sizing on insert (it collapses to blank until a re-parse).
        const iframeEl = htmlElement.getElementsByTagName('iframe')[0]
        if (iframeEl) {
          let fbSrc = iframeEl.getAttribute('src')
          // Preserve the embed's own height in the URL fragment. Post heights vary per post
          // and aren't in the plugin query; the fragment survives HTML round-trips and is
          // ignored by Facebook. Facebook.tsx reads it for the initial iframe height.
          const hAttr = iframeEl.getAttribute('height')
          if (fbSrc && hAttr && fbSrc.indexOf('#') === -1) {
            fbSrc = `${fbSrc}#h=${hAttr}`
          }
          newAttrs = {
            src: fbSrc,
          }
        }
      }
      if (match[0].indexOf('vimeo.com') > -1) {
        // Keep ONLY the src, read via getAttribute for a clean, entity-decoded value.
        // Vimeo's responsive embed code carries style="position:absolute;…", and copying the
        // raw attributes handed React a `style` *string*, which throws "Failed to set an
        // indexed property [0] on 'CSSStyleDeclaration'" and tore the element out of the
        // tree — the modal closed with nothing inserted. Embeds.tsx renders Vimeo as a
        // controlled iframe with a fixed attribute set, so those attributes aren't needed
        // (same as the Facebook branch above).
        const vimeoIframe = htmlElement.getElementsByTagName('iframe')[0]
        if (vimeoIframe) {
          newAttrs = {
            src: vimeoIframe.getAttribute('src'),
          }
        }
      }
    })
  }
  return newAttrs
}

export const blockQuoteUrl = (url) => {
  let newAttrs;
  // Normalize smart/curly quotes to straight quotes (see iFrameUrl).
  let data = url?.replace(/[‘’]/g, "'").replace(/[“”]/g, '"');
  if (data) {
    const parser = new DOMParser();
    const htmlElement = parser.parseFromString(data, "text/html");

    const blockQuoteElement = htmlElement.getElementsByTagName('blockquote');
    const embedType = blockQuoteElement[0]?.className
    const attrs = blockQuoteElement[0]?.getAttributeNames()
    switch (embedType) {
      case 'twitter-tweet':
        newAttrs = blockQuoteElement[0].lastChild?.href
        break;
      case 'tiktok-embed':
        newAttrs = {
          src: blockQuoteElement[0].getAttribute('cite'),
        }
        attrs.forEach((attribute) => {
          if (attribute === 'style') {
            newAttrs[attribute] = getStyleObjectFromString(blockQuoteElement[0].getAttribute(attribute))
          }
          else {
            newAttrs[attribute] = blockQuoteElement[0].getAttribute(attribute)
          }
        })
        break;
      case 'instagram-media':
        newAttrs = {
          src: blockQuoteElement[0].getAttribute('data-instgrm-permalink'),
        }
        attrs.forEach((attribute) => {
          if (attribute === 'style') {
            newAttrs[attribute] = getStyleObjectFromString(blockQuoteElement[0].getAttribute(attribute))
          }
          else {
            newAttrs[attribute] = blockQuoteElement[0].getAttribute(attribute)
          }
        })
        break;
      default:
        break;
    }
  }
  return newAttrs
}

export const isValidUrl = (url) => {
  return (findEmbedType(url))
}

const formatStringToCamelCase = str => {
  const splitted = str.split("-");
  if (splitted.length === 1) return splitted[0];
  return (
    splitted[0] +
    splitted
      .slice(1)
      .map(word => word[0].toUpperCase() + word.slice(1))
      .join("")
  );
};

const getStyleObjectFromString = str => {
  const style = {};
  str.split(";").forEach(el => {
    const [property, value] = el.split(":");
    if (!property) return;

    const formattedProperty = formatStringToCamelCase(property.trim());
    style[formattedProperty] = value.trim();
  });

  return style;
};


export const changeIframeWidth = (src, width, ref) => {
  if (src.indexOf('tiktok.com') > -1) {
    const handleEvent = (e) => {
      if (e.origin === "https://www.tiktok.com" && (e.data)) {
        if (ref.current.getElementsByTagName('iframe')[0].contentWindow === e.source) {
          if (JSON.parse(e.data).width !== 0) {
            ref.current.getElementsByTagName('iframe')[0].style.width = `${width}px`
            window.removeEventListener('message', handleEvent)
          }
        }
      }
    }
    if (ref.current) {
      window.addEventListener('message', handleEvent)
    }
  }
  else if (src.indexOf('facebook.com') > -1) {
    const handleEvent = (e) => {
      if (e.origin === "https://www.facebook.com" && (e.data)) {
        if (ref.current?.getElementsByTagName('iframe')[0].contentWindow === e.source) {
          const urlArray = ref.current.getElementsByTagName('iframe')[0].src.split("&")
          if (urlArray[urlArray.length - 1]) {
            urlArray[urlArray.length - 1] = `width=${width}`
          }
          ref.current.getElementsByTagName('iframe')[0].src = urlArray.join("&")
          window.removeEventListener('message', handleEvent)
        }
      }
    }
    if (ref.current) {
      window.addEventListener('message', handleEvent)
    }
  }
}